import { z } from "zod";

const category = z.object({
  brand: z.string(),
  categoryIcon: z.string(),
  categoryId: z.union([
    z.literal("NJU_NWT_OFFER_INFO_OFFER"),
    z.literal("NJU_NWT_OFFER_INFO"),
    z.literal("NJU_NWT_OFFER_INFO_SYSTEM"),
    z.literal("NJU_NWT_OFFER_INFO_FAQ"),
  ]),
  categoryName: z.object({
    id: z.number(),
    en: z.string().or(z.null()),
    pl: z.string().or(z.null()),
    uk: z.string().or(z.null()),
  }),
  displayMobile: z.boolean(),
  displayWeb: z.boolean(),
  priority: z.number(),
  state: z.union([z.literal("PUBLISHED"), z.literal("DRAFT")]),
});

const document = z.object({
  state: z.enum(["PUBLISHED", "ARCHIVED"]),
  availableFrom: z.string().or(z.null()).optional(),
  availableUntil: z.string().or(z.null()).optional(),
  title: z.object({
    pl: z.string(),
  }),
  url: z.string().optional(),
  fileName: z.string().optional(),
  categories: z.array(category),
});

export const serverResponse = z.array(document);
export type IDocument = z.infer<typeof document>;
export type ICategory = z.infer<typeof category>;
